import QRCode from 'qrcode';

// Same options as the V1 server implementation — 87px matches the white frame
// inside the folder-tab card in the injected PDF header.
export const generateQrSvg = (url: string): Promise<string> =>
  QRCode.toString(url, {
    type: 'svg',
    width: 87,
    margin: 1,
    errorCorrectionLevel: 'M',
    color: { dark: '#000000', light: '#ffffff' },
  });
